import { render, staticRenderFns } from "./Scroll.vue?vue&type=template&id=25883115&scoped=true"
import script from "./Scroll.vue?vue&type=script&lang=js"
export * from "./Scroll.vue?vue&type=script&lang=js"
import style0 from "./Scroll.vue?vue&type=style&index=0&id=25883115&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25883115",
  null
  
)

export default component.exports